<!--
  NOTICE: This component is used throughout the application.
  If changing, ensure it remains reusable and does not break existing usage.
  For specific customizations, add an appropriate parameter.
-->
<div
  class="d-flex w-100 h-100"
  [ngClass]="{
    'overlay-loading': variant === 'overlay',
    'default-loading': variant === 'default',
    'inline-loading': variant === 'inline',
    'freeze-loading': variant === 'freeze',
    small: isSmall,
  }"
  *ngIf="showLoading"
>
  <div
    class="d-flex flex-column w-100 text-center align-self-center panel-contente"
  >
    <div class="lds-ripple mx-auto">
      <div></div>
      <div></div>
    </div>
    <div *ngIf="!hideText" class="loading-message">
      {{ 'public.load.loadingMessage' | translate }}
    </div>
  </div>
</div>
